const customLinkConstants = {
  JustBooked: {
    toggleLabel: 'Use custom link',
    toggleHint: 'Enable this if you want to send your own custom links.'
  },
  CheckedOutReview: {
    toggleLabel: 'Use custom review link',
    toggleHint: 'Enable this if you want to send your own review links.'
  }
}

export default customLinkConstants
